import { Pipe, PipeTransform } from '@angular/core';
import { Batch } from '../../models';
import { OPEN, PRINTING, SEALED, RUSH, PRINTING_ABORTED } from 'ngrx/status-types';

@Pipe({
  name: 'openBatches'
})
export class OpenBatchesPipe implements PipeTransform {
  transform(batches: Batch[], open: boolean) {
    return batches.filter(batch => {
      return open 
        ? batch.batchStatus === OPEN || batch.batchStatus === SEALED || batch.batchStatus === RUSH || batch.batchStatus === PRINTING_ABORTED
        : batch.batchStatus === PRINTING
    });
  }
}


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/pipes/open-batches.pipe.ts